<template>
  <div class="carousel">
    <div class="track">
      <div class="slide" v-for="(src, index) in images" :key="`img-${index}`">
        <img :src="src" alt="foto" />
      </div>
      <div class="slide" v-for="(src, index) in images" :key="`dup-${index}`">
        <img :src="src" alt="foto" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PhotoCarousel',
  props: {
    images: {
      type: Array as () => string[],
      required: true
    }
  }
})
</script>

<style scoped lang="scss">
.carousel {
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
  position: relative;
  z-index: 0;
}

.track {
  display: flex;
  width: max-content;
  height: 100%;
  animation: scroll 28s linear infinite;
  position: relative;
  z-index: 0;
}

.slide {
  flex: 0 0 100%;
  height: 100%;
  position: relative;
  z-index: 0;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  position: relative;
  z-index: 0;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
